import { Link } from "react-router-dom"
import BlogPost from "./BlogPost"
import { blogPosts } from "./BlogData"
import useUIStyles from "../../../Hooks/useUIStyles";

function BlogPage() {
  const { heading, title, description } = useUIStyles();

  return (
    <div className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-3 sm:px-4">
        <div className="mb-10">
          <h2 className="section-heading text-[28px] md:text-[32px]">
            Journal
          </h2>
          <p className="text-stone-500 mt-2 max-w-3xl">
            Stay updated with the latest fashion trends, styling tips, and designer insights
          </p>
        </div>

        {/* Enhanced Blog Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {blogPosts.map(post => (
            <div key={post.id} className="group">
              <BlogPost post={post} />
            </div>
          ))}
        </div>

        {/* Enhanced CTA Button */}
        <div className="text-center">
          <Link
            to="#"
            className="inline-flex items-center px-8 py-3 border border-stone-800 text-stone-800 hover:bg-stone-800 hover:text-white transition-colors group"
          >
            GO TO BLOGS
            <svg className="w-5 h-5 ml-3 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default BlogPage
